const map = {
	"./ModuleAiTools/AiVideoGenerator/registry/routes.js": 42469,
	"./ModuleCommunity/Course/registry/routes.js": 32682,
	"./ModuleCommunity/CourseLesson/registry/routes.js": 3054,
	"./ModuleCommunity/CourseReview/registry/routes.js": 24734,
	"./ModuleCommunity/CourseStudent/registry/routes.js": 93857,
	"./ModuleCommunity/FeaturedContent/registry/routes.js": 53902,
	"./ModuleCompany/BCBusinessSector/registry/routes.js": 66342,
	"./ModuleCompany/BCEconomicSector/registry/routes.js": 23017,
	"./ModuleCompany/BCIndustry/registry/routes.js": 69680,
	"./ModuleCompany/BCIndustryActivity/registry/routes.js": 70761,
	"./ModuleCompany/BCIndustryGroup/registry/routes.js": 88879,
	"./ModuleCompany/Company/registry/routes.js": 68948,
	"./ModuleCompany/ExtractFinanceStatement/registry/routes.js": 23917,
	"./ModuleCompany/GoldExchange/registry/routes.js": 76982,
	"./ModuleCompany/GoldSnapshot/registry/routes.js": 58719,
	"./ModuleCompany/NewsArticle/registry/routes.js": 97836,
	"./ModuleCompany/NewsSummary/registry/routes.js": 25834,
	"./ModuleCompany/PromptGenAi/registry/routes.js": 53129,
	"./ModuleCompany/SeIndexSnapshot/registry/routes.js": 16883,
	"./ModuleCompany/StockAnalysisReport/registry/routes.js": 60693,
	"./ModuleConsole/ServiceRegister/registry/routes.js": 12871,
	"./ModuleConsole/ServiceSchema/registry/routes.js": 68601,
	"./ModuleCore/AppReleaseNotices/registry/routes.js": 69272,
	"./ModuleCore/Billing/registry/routes.js": 88346,
	"./ModuleCore/BillingDetail/registry/routes.js": 32583,
	"./ModuleCore/BillingTransaction/registry/routes.js": 81778,
	"./ModuleCore/ConfigSystem/registry/routes.js": 66228,
	"./ModuleCore/ContactForm/registry/routes.js": 62795,
	"./ModuleCore/GlobalConfig/registry/routes.js": 86662,
	"./ModuleCore/IntegrationLog/registry/routes.js": 16339,
	"./ModuleCore/MembershipCashPlan/registry/routes.js": 45111,
	"./ModuleCore/MembershipPlan/registry/routes.js": 54404,
	"./ModuleCore/MembershipPlanUser/registry/routes.js": 86643,
	"./ModuleCore/MembershipSubscriptionUser/registry/routes.js": 64245,
	"./ModuleCore/MiniAppConfig/registry/routes.js": 24645,
	"./ModuleCore/Order/registry/routes.js": 70801,
	"./ModuleCore/PaymentMode/registry/routes.js": 32572,
	"./ModuleCore/PromotionCoupon/registry/routes.js": 57658,
	"./ModuleCore/PromotionCouponRedemption/registry/routes.js": 99675,
	"./ModuleCore/PromotionRule/registry/routes.js": 44858,
	"./ModuleCore/ReferralRegistration/registry/routes.js": 26379,
	"./ModuleCore/ReferralReward/registry/routes.js": 64353,
	"./ModuleCore/ReferralTransition/registry/routes.js": 8637,
	"./ModuleCore/ReferralWithdrawal/registry/routes.js": 52081,
	"./ModuleCore/ReferrerRewardPlan/registry/routes.js": 34020,
	"./ModuleCore/SecuritiesAccount/registry/routes.js": 54284,
	"./ModuleCore/SecuritiesAccountForm/registry/routes.js": 52694,
	"./ModuleCore/SecuritiesSubAccount/registry/routes.js": 89512,
	"./ModuleCore/Tenant/registry/routes.js": 15215,
	"./ModuleCore/TenantAuthConfig/registry/routes.js": 93719,
	"./ModuleCore/TenantUserMapping/registry/routes.js": 82722,
	"./ModuleCore/TenantWebhook/registry/routes.js": 73748,
	"./ModuleCore/User/registry/routes.js": 61200,
	"./ModuleCore/UserCash/registry/routes.js": 78303,
	"./ModuleCore/UserCashDetail/registry/routes.js": 61074,
	"./ModuleCore/UserCashPlan/registry/routes.js": 21920,
	"./ModuleCore/UserCashTransaction/registry/routes.js": 8029,
	"./ModuleCore/UserForceSession/registry/routes.js": 86597,
	"./ModuleCore/UserLoginActivity/registry/routes.js": 7012,
	"./ModuleCore/UserReferral/registry/routes.js": 12221,
	"./ModuleCore/UserReferralPlan/registry/routes.js": 9018,
	"./ModuleCore/UserReferralReward/registry/routes.js": 38754,
	"./ModuleCrm/CampaignSale/registry/routes.js": 92845,
	"./ModuleCrm/CampaignZone/registry/routes.js": 34348,
	"./ModuleCrm/CompanyReport/registry/routes.js": 74809,
	"./ModuleCrm/ContentTemplate/registry/routes.js": 32363,
	"./ModuleCrm/CustomField/registry/routes.js": 76453,
	"./ModuleCrm/PopupInfo/registry/routes.js": 39198,
	"./ModuleCrm/PopupUser/registry/routes.js": 87641,
	"./ModuleCrm/SegmentUser/registry/routes.js": 39382,
	"./ModuleCrm/Segments/registry/routes.js": 94662,
	"./ModuleCrm/TagUser/registry/routes.js": 9695,
	"./ModuleCrm/Tags/registry/routes.js": 64381,
	"./ModuleCrm/UserFeedback/registry/routes.js": 95592,
	"./ModuleCrm/UserInfo/registry/routes.js": 97207,
	"./ModuleCrm/WallOfLove/registry/routes.js": 10793,
	"./ModuleCrm/WorkflowTrigger/registry/routes.js": 14895,
	"./ModuleCrm/WorkflowTriggerUser/registry/routes.js": 92432,
	"./ModuleCrm/Zone/registry/routes.js": 50466,
	"./ModuleDashboard/ModuleDashboard/registry/routes.js": 29744,
	"./ModuleFileManager/FileManager/registry/routes.js": 35692,
	"./ModuleNotification/NotificationModule/registry/routes.js": 97068,
	"./ModuleNotification/NotificationMsgTemplate/registry/routes.js": 87343,
	"./ModuleNotification/NotificationSetting/registry/routes.js": 43164,
	"./ModuleNotification/NotificationSnapshot/registry/routes.js": 40252,
	"./ModuleNotification/NotificationType/registry/routes.js": 40208,
	"./ModuleNotification/NotificationTypeGroup/registry/routes.js": 90127,
	"./ModuleNotification/OtpTracking/registry/routes.js": 2149,
	"./ModuleNotification/SmSubscribeTracking/registry/routes.js": 14880,
	"./ModuleNotification/SmsTrackingLog/registry/routes.js": 9645,
	"./ModulePersonalize/CompanyNote/registry/routes.js": 86045,
	"./ModulePersonalize/IntegrationLog/registry/routes.js": 64194,
	"./ModulePersonalize/NebulaBrainDailyTrade/registry/routes.js": 92294,
	"./ModulePersonalize/NebulaBrainHistory/registry/routes.js": 88021,
	"./ModulePersonalize/NebulaDecisionTemplates/registry/routes.js": 34818,
	"./ModulePersonalize/NebulaDecisions/registry/routes.js": 90908,
	"./ModulePersonalize/NebulaHoldings/registry/routes.js": 79889,
	"./ModulePersonalize/NebulaManagementFee/registry/routes.js": 16918,
	"./ModulePersonalize/NebulaMetadata/registry/routes.js": 23164,
	"./ModulePersonalize/NebulaOrders/registry/routes.js": 88016,
	"./ModulePersonalize/NebulaPerfFeeAmortized/registry/routes.js": 7317,
	"./ModulePersonalize/NebulaPerformance/registry/routes.js": 21305,
	"./ModulePersonalize/NebulaPerformanceFee/registry/routes.js": 83495,
	"./ModulePersonalize/NebulaPerformanceLog/registry/routes.js": 77305,
	"./ModulePersonalize/NebulaPositions/registry/routes.js": 25235,
	"./ModulePersonalize/NebulaProfile/registry/routes.js": 83594,
	"./ModulePersonalize/NebulaRewardTransaction/registry/routes.js": 55562,
	"./ModulePersonalize/NebulaStatistics/registry/routes.js": 54630,
	"./ModulePersonalize/NebulaTradingTransaction/registry/routes.js": 26614,
	"./ModulePersonalize/NebulaTransactions/registry/routes.js": 86352,
	"./ModulePersonalize/NebulaUltraFees/registry/routes.js": 91020,
	"./ModulePersonalize/NebulaUltraLog/registry/routes.js": 11205,
	"./ModulePersonalize/NebulaUltraMetadata/registry/routes.js": 76756,
	"./ModulePersonalize/NebulaUltraPlan/registry/routes.js": 44610,
	"./ModulePersonalize/NebulaUltraTransactions/registry/routes.js": 42200,
	"./ModulePersonalize/NebulaUserProfile/registry/routes.js": 98703,
	"./ModulePersonalize/NebulaUserProfileHistory/registry/routes.js": 57817,
	"./ModulePersonalize/PnlConfigSystem/registry/routes.js": 27467,
	"./ModulePersonalize/PortfolioList/registry/routes.js": 6586,
	"./ModulePersonalize/PortfolioStock/registry/routes.js": 58312,
	"./ModulePersonalize/PortfolioSub/registry/routes.js": 10756,
	"./ModulePersonalize/PortfolioWallet/registry/routes.js": 44699,
	"./ModulePersonalize/PortfolioWalletMarginHistory/registry/routes.js": 91595,
	"./ModulePersonalize/TaIndicatorConfig/registry/routes.js": 92044,
	"./ModulePersonalize/TaSignalConfig/registry/routes.js": 95811,
	"./ModulePersonalize/UserScreener/registry/routes.js": 7054,
	"./ModulePersonalize/UserScreenerClient/registry/routes.js": 98073,
	"./ModulePersonalize/UserWorkspace/registry/routes.js": 26418,
	"./ModulePersonalize/Watchlist/registry/routes.js": 15425,
	"./ModulePersonalize/WatchlistItem/registry/routes.js": 59102,
	"./ModuleRole/Permission/registry/routes.js": 28633,
	"./ModuleRole/PermissionGroup/registry/routes.js": 57236,
	"./ModuleRole/PermissionGroupMapping/registry/routes.js": 90998,
	"./ModuleRole/PermissionGroupUser/registry/routes.js": 85859,
	"./ModuleRole/UserAuthority/registry/routes.js": 96190,
	"./ModuleRole/UserAuthorityMapping/registry/routes.js": 73116,
	"./ModuleSearch/WidgetDocumentSearch/registry/routes.js": 42799
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78972;